import { computed } from "vue";
import { useCursoStore } from "@/store/cursoStore";
import { useGuardianStore } from "@/store/guardianStore";
import { canAssociateExtraGuardians, courseRequiresStudentName, getGroupSelectorTitle, } from "@/utils/parseCourseCode";
import { looksLikeEmail } from "@/utils/guardianDisplayName";
const displayPersonName = (value) => {
    const name = String(value || "").trim();
    if (!name || looksLikeEmail(name))
        return null;
    return name;
};
export const resolveGuardianContext = (course, options) => {
    const empty = {
        role: "none",
        primaryGuardianName: null,
        studentName: null,
        groupName: null,
        hasStudent: false,
    };
    if (!course) {
        if (options?.isLoading)
            return { ...empty, role: "unknown" };
        return empty;
    }
    if (course.isExtraGuardian === undefined && options?.isLoading) {
        return {
            ...empty,
            studentName: displayPersonName(course.student_name),
            groupName: getGroupSelectorTitle(course) || null,
            hasStudent: courseRequiresStudentName(course),
            role: "unknown",
        };
    }
    const studentName = displayPersonName(course.student_name);
    const groupName = getGroupSelectorTitle(course) || null;
    const hasStudent = courseRequiresStudentName(course);
    if (course.isExtraGuardian === true) {
        return {
            role: "additional",
            primaryGuardianName: displayPersonName(course.master_user_name),
            studentName,
            groupName,
            hasStudent,
        };
    }
    if (canAssociateExtraGuardians(course)) {
        return {
            role: "primary",
            primaryGuardianName: null,
            studentName,
            groupName,
            hasStudent,
        };
    }
    return {
        role: "none",
        primaryGuardianName: null,
        studentName,
        groupName,
        hasStudent,
    };
};
const courseSeq = (course) => String(course?.studend_userCourse_seq || course?.student_userCourse_seq || "");
const isSameCourseMembership = (left, right) => left.school_id === right.school_id &&
    String(left.year) === String(right.year) &&
    String(left.course_id) === String(right.course_id) &&
    String(left.student_name || "") === String(right.student_name || "") &&
    courseSeq(left) === courseSeq(right);
export const useGuardianContext = () => {
    const cursoStore = useCursoStore();
    const guardianStore = useGuardianStore();
    const activeCourse = computed(() => {
        const selected = (cursoStore.selectedCursoData ||
            cursoStore.getCursoData());
        if (!selected)
            return null;
        const fresh = guardianStore.courses.find((course) => isSameCourseMembership(course, selected));
        return fresh ? { ...selected, ...fresh } : selected;
    });
    const guardianContext = computed(() => resolveGuardianContext(activeCourse.value, {
        isLoading: guardianStore.isLoading,
    }));
    const isPrimaryGuardian = computed(() => guardianContext.value.role === "primary");
    const isAdditionalGuardian = computed(() => guardianContext.value.role === "additional");
    const isGuardianRolePending = computed(() => guardianContext.value.role === "unknown");
    return {
        activeCourse,
        guardianContext,
        isPrimaryGuardian,
        isAdditionalGuardian,
        isGuardianRolePending,
    };
};
